// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gl-3";
export var downloadButton = "_gl-4";
export var fileContainer = "_gl-9 _gl-7";
export var fileContainerBase = "_gl-7";
export var fileContainerBaseSm = "_gl-a _gl-7";
export var fileContainerFixedHeight = "_gl-8 _gl-7";
export var fileContainerFixedHeightSm = "_gl-c _gl-a _gl-7";
export var fileContainerSm = "_gl-b _gl-a _gl-7";
export var fileInfo = "_gl-5";
export var fileInfoWidthRestricted = "_gl-6";
export var fileType = "_gl-1";
export var fileTypeName = "_gl-2";
export var fileTypeSm = "_gl-d _gl-1";
export var image = "_gl-0";
export var link = "_gl-f";
export var overflowEllipsis = "_gl-e";